<template>
  <div class="sidebar-account organisation">
    <div class="text lead mb-0 d-flex">
      <span class="mr-2">{{ getCompanyTitle() }}</span>
      <b-dropdown
        class="ml-auto"
        style="height: max-content"
        variant="primary"
        id="dropdown-1"
        v-if="isMultiPartner"
        right
        size="sm"
      >
        <template #button-content>
          <font-awesome-icon :icon="['fa', 'sync']" />
        </template>
        <b-dropdown-item disabled>Смена организации </b-dropdown-item>
        <div v-for="(org, key) in switchOrganisationList" :key="key">
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item
            class="dropdown-class"
            @click="onSwitchOrganisation(org)"
          >
            {{ org.title }}
          </b-dropdown-item>
        </div>
      </b-dropdown>
    </div>

    <p class="text text-muted mb-2">{{ getInitials() }}</p>
    <p />

    <WarningModal
      size="md"
      v-if="switchOrganisation"
      id="switchOrgModal"
      ref="switchOrgModal"
      title="Смена организации"
    >
      <div>Ваш аккаунт привязан к нескольким организациям.</div>

      <hr />
      <div>
        Текущая организация: <strong>{{ getCompanyTitle() }}</strong>
      </div>

      <div class="mt-2">
        Вы уверены, что хотите сменить просмотр на
        <strong>{{ switchOrganisation.title }}</strong
        >?
      </div>
    </WarningModal>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { userMappers } from '@/store/modules/user'
import WarningModal from '@/components/ui/WarningModal.vue'
import PartnersAPI from '@/api/partners'
import { clientBaseWithSlash } from '@/config/urls'

const Mappers = Vue.extend({
  computed: {
    ...userMappers.mapGetters([
      'currentUser',
      'partnerPosition',
      'isMultiPartner',
      'allPartnerCompanies'
    ])
  }
})

@Component({ components: { WarningModal } })
export default class Organisation extends Mappers {
  private switchOrganisation: any = null

  $refs!: {
    switchOrgModal: WarningModal
  }

  private getInitials() {
    return this.currentUser && this.currentUser.initials
      ? this.currentUser.initials
      : 'Неизвестный'
  }

  private get switchOrganisationList() {
    return this.allPartnerCompanies.filter(
      c => c.id !== this.partnerPosition?.company?.id
    )
  }

  private async onSwitchOrganisation(organisation: any) {
    this.switchOrganisation = organisation
    await this.$nextTick()

    this.$refs.switchOrgModal.show(async () => {
      await PartnersAPI.changeCompany(this.switchOrganisation.id)
      this.switchOrganisation = null
      window.location.reload()
      window.location.href = clientBaseWithSlash
    })
  }

  private getCompanyTitle() {
    const company = this.partnerPosition
    return company?.company?.title ?? ''
  }
}
</script>

<style lang="scss">
@import '@/scss/_colors.scss';

.organisation {
  .text {
    padding: 0rem 0.5rem 0rem 1rem;
  }
  .dropdown-class {
    width: 250px;
    .dropdown-item {
      white-space: break-spaces !important;
      padding: 0.5rem 1rem;
    }
    .dropdown-item::first-letter {
      margin-left: 0px !important;
    }
  }
}
</style>
